module.exports = __webpack_public_path__ + "img/pad1.bbc255a1.svg";